import { PaymentSource, PaymentTokenType, PaymentTransactionType, PaymentType } from './PaymentEnums';

export type PaymentInput = {
  reference: string;
  accountNumber: string;
  emailAddress: string;
  paymentTokenType: PaymentTokenType;
  paymentToken: string;
  paymentRegion: string;
  transactionType: PaymentTransactionType;
  amount: number;
  paymentType: PaymentType;
  source: PaymentSource;
  postcode?: string;
};

export interface PaymentRequestStripe {
  accountNumber: string;
  amount: number;
  customerNumber?: string;
  emailAddress?: string;
  isSavePayment: boolean;
  paymentMethodId: string;
  paymentSourceMethod: PaymentMethodType;
  source: PaymentSource;
  transactionType: string;
  postcode?: string;
}
export enum PaymentMethodType {
  /**
   * Payment made using a card.
   */
  CC_ADHOC = 'CC_ADHOC',

  /**
   * Payment made using a card from IVR.
   */
  CC_IVR = 'CC_IVR',

  /**
   * Payment made using PayPal.
   */
  PAYPAL_ADHOC = 'PAYPAL_ADHOC',

  /**
   * Payment made using Apple Pay.
   */
  APPLEPAY_ADHOC = 'APPLEPAY_ADHOC',

  /**
   * Payment made using Google Pay.
   */
  GOOGLEPAY_ADHOC = 'GOOGLEPAY_ADHOC'
}
